import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

const HintLabel = ({ label, hint }) => (
  <Tooltip title={hint} placement='topLeft' styles={{ root: { maxWidth: 420 } }}>
    <span tabIndex={0} style={{ cursor: 'help' }}>
      {label} <QuestionCircleOutlined style={{ fontSize: 12, color: 'var(--journey-muted)' }} />
    </span>
  </Tooltip>
)

HintLabel.propTypes = {
  label: PropTypes.node.isRequired,
  hint: PropTypes.node.isRequired
}

export { HintLabel }
